import { render, staticRenderFns } from "./L3VincenzHeroHeader.vue?vue&type=template&id=3ef5688c&scoped=true&"
import script from "./L3VincenzHeroHeader.vue?vue&type=script&lang=ts&"
export * from "./L3VincenzHeroHeader.vue?vue&type=script&lang=ts&"
import style0 from "./L3VincenzHeroHeader.vue?vue&type=style&index=0&id=3ef5688c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5688c",
  null
  
)

export default component.exports